/*
创建者 魏强(2018.1.25)
横栏广告
*/
<template>
	<div class="mt10" v-if="list.length>0">
		<Carousel
            v-model="value"
            :autoplay="setting.autoplay"
            :autoplay-speed="setting.autoplaySpeed"
            :dots="setting.dots"
            :radius-dot="setting.radiusDot"
            :trigger="setting.trigger"
            :arrow="setting.arrow"

        >
            <CarouselItem v-for="item in list" :key="item.key" >
                <div :style="styleObject">
                    <router-link :to="item.to" target="_blank">
						<img :src="item.atturl" :height="size.height" :alt="item.aname" :width="size.width" />
					</router-link>
                </div>
            </CarouselItem>
        </Carousel>
			
	</div>
</template>
<script>
import {parseAdvList} from 'utils/tool.js';
export default {
	props:["data","size"],
	computed:{
        styleObject:function(){
            return {
                height:this.size?this.size.height:"100px",
                width:this.size?this.size.width:"1190px;"
            }
        },
        list:function(){
        	return this.data ? parseAdvList(this.data) : []
        }
    },
	data(){
		return {
			value:0,
            setting: {
                autoplay: true,
                autoplaySpeed: 5000,
                dots: (!!this.data&&this.data.length>1)?'inside':"none",
                radiusDot: true,
                trigger: 'hover',
                arrow: 'never'
            } 
		}
	},
	created(){
	},
	methods:{
		
	}
}
</script>


// WEBPACK FOOTER //
// index.vue?5892d370